import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { MatSlideToggleModule } from '@angular/material/slide-toggle'
import { RouterModule } from '@angular/router'
import { CmsConfig, FeaturesConfigModule, I18nModule, UrlModule, provideDefaultConfig } from '@spartacus/core'
import {
  AtMessageModule,
  IconModule,
  ItemCounterModule,
  ListNavigationModule,
  MediaModule,
  OutletModule,
  PageComponentModule,
  SpinnerModule,
  StarRatingModule,
  ViewConfig,
  defaultViewConfig
} from '@spartacus/storefront'
import { InfiniteScrollModule } from 'ngx-infinite-scroll'
import { CustomAddToCartModule } from '../../cart/add-to-cart/custom-add-to-cart.module'
import { ActionButtonComponent } from '../../shared/action-button/action-button.component'
import { CustomProductReplacementModule } from '../custom-product-replacement/custom-product-replacement.module'
import { CustomProductGridItemComponent } from './custom-product-grid-item/custom-product-grid-item.component'
import { CustomProductListItemComponent } from './custom-product-list-item/custom-product-list-item.component'
import { CustomProductListComponent } from './custom-product-list.component'
import { CustomProductScrollComponent } from './custom-product-scroll/custom-product-scroll.component'
import { CustomProductViewComponent } from './custom-product-view/custom-product-view.component'

@NgModule({
  imports: [
    AtMessageModule,
    CommonModule,
    FeaturesConfigModule,
    I18nModule,
    IconModule,
    InfiniteScrollModule,
    ItemCounterModule,
    ListNavigationModule,
    MediaModule,
    OutletModule,
    PageComponentModule,
    RouterModule,
    SpinnerModule,
    StarRatingModule,
    UrlModule,
    MatSlideToggleModule,
    CustomAddToCartModule,
    CustomProductReplacementModule
  ],
  providers: [
    provideDefaultConfig(<ViewConfig>defaultViewConfig),
    provideDefaultConfig(<CmsConfig>{
      cmsComponents: {
        CMSProductListComponent: {
          component: CustomProductListComponent,
          data: {
            composition: {
              inner: ['ProductAddToCartComponent']
            }
          }
        },
        SearchResultsListComponent: {
          component: CustomProductListComponent,
          data: {
            composition: {
              inner: ['ProductAddToCartComponent']
            }
          }
        }
      }
    })
  ],
  declarations: [
    ActionButtonComponent,
    CustomProductListComponent,
    CustomProductListItemComponent,
    CustomProductGridItemComponent,
    CustomProductScrollComponent,
    CustomProductViewComponent
  ],
  exports: [
    ActionButtonComponent,
    CustomProductListComponent,
    CustomProductListItemComponent,
    CustomProductGridItemComponent,
    CustomProductScrollComponent,
    CustomProductViewComponent
  ]
})
export class CustomProductListModule {}
